import { render } from "./WarmTransferPhoneNumber.vue?vue&type=template&id=26d70a5f"
import script from "./WarmTransferPhoneNumber.vue?vue&type=script&lang=js"
export * from "./WarmTransferPhoneNumber.vue?vue&type=script&lang=js"
script.render = render

export default script